// extracted by mini-css-extract-plugin
export var label = "_b4-5";
export var slideContainer = "_b4-0";
export var slider = "_b4-1";
export var sliderLg = "_b4-4";
export var sliderMd = "_b4-3";
export var sliderSm = "_b4-2";